/*
 *
 * Package: `@dbh/tab-list-theme`.
 *
 */const THEME_KEY_TAB_LIST="tabList";const modifyTabListTheme=a=>{let{colors:{transparent:b,brandThird:c,brandThirdMid:d},fonts:{size:{ff7:g},style:{medium:h,light:i},transform:{uppercase:j}},spacing:{sp4:e,sp10:f}}=a;return {[THEME_KEY_TAB_LIST]:{root:{// Controls the width of the component, use 100% to make it fluid.
width:"100%"},indicator:{height:"4px",backgroundColor:c},tab:{height:f,textSize:g,textTransform:j,padding:"0 "+e,idle:{color:d,backgroundColor:b,textStyle:i},selected:{color:c,backgroundColor:b,textStyle:h}}}}};

export { THEME_KEY_TAB_LIST, modifyTabListTheme as default };
